/** Mission polyline only for non-terminal orders; completed orders still carry `missionId` in API/cache.
 * Accepts `unknown` because this repo has multiple `OrderEntity` shapes from GET /orders/:id. */
export function missionIdFromOrderForActiveRoute(order: unknown): string | undefined {
  if (!order || typeof order !== 'object') return undefined;
  const o = order as { status?: string; missionId?: string };
  if (!o.missionId || o.status == null) return undefined;
  const s = String(o.status).toLowerCase();
  if (s === 'completed' || s === 'cancelled' || s === 'error') return undefined;
  return o.missionId;
}
